import script from "./solution-to-resolve-subscription-invalid-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./solution-to-resolve-subscription-invalid-dialog.vue?vue&type=script&lang=ts&setup=true"

import "./solution-to-resolve-subscription-invalid-dialog.vue?vue&type=style&index=0&id=4a2d5444&lang=scss"

const __exports__ = script;

export default __exports__